import React from "react"
import { Link } from "gatsby"

// Breadcrumb component taking day and title as props
const Breadcrumb = ({ title }) => {
  return (
    <div className="truncate">
      <Link to="/">Home</Link>
      <span>&nbsp;&nbsp;/&nbsp;&nbsp;</span>
      <Link to="#">{title}</Link>
    </div>
  )
}

export default Breadcrumb
